<template>
  <div class="el-upload">
    <el-form>
      <el-upload
        :limit="limitNumber"
        action=""
        accept="image/*"
        :http-request="uploadFile"
        :auto-upload="true"
        :on-preview="handlePictureCardPreview"
        :on-exceed="handleExceed"
        :before-remove="beforeRemove"
        ref="upload"
        :show-file-list="false"
        class="uploadBefore"
      >
        <div v-if="type == 0">
          <img v-if="imageUrl" :src="imageUrl" class="avatar" />
          <i v-else class="el-icon-plus icon"></i>
        </div>
        <div v-if="type == 1">
          <img v-if="imageUrl1" :src="imageUrl1" class="avatar" />
          <!-- <i v-else class="el-icon-plus icon"></i> -->
          <div v-else class="avatarNone">
            <div style="padding-top: 24px">
              <img
                style="width: 64px; height: 50px"
                src="../../../assets/xiangji.png"
              />
            </div>

            <span
              style="
                font-size: 18px;
                font-family: PingFang SC;
                font-weight: 400;
                line-height: 32px;
                color: #4168e7;
              "
              >上传身份证正面</span
            >
          </div>
        </div>
        <div v-if="type == 2">
          <img v-if="imageUrl2" :src="imageUrl2" class="avatar" />
          <div v-else class="avatarNone">
            <div style="padding-top: 24px">
              <img
                style="width: 64px; height: 50px"
                src="../../../assets/xiangji.png"
              />
            </div>

            <span
              style="
                font-size: 18px;
                font-family: PingFang SC;
                font-weight: 400;
                line-height: 32px;
                color: #4168e7;
              "
              >上传身份证反面</span
            >
          </div>
        </div>
      </el-upload>
      <el-dialog :visible.sync="dialogVisible" append-to-body>
        <img width="100%" fit="contain" :src="dialogImageUrl" alt="" />
      </el-dialog>
    </el-form>
  </div>
</template>
<script>
// import { uploadImg, delUpIamge } from '@/api/publicSeries'
export default {
  props: {
    limitNumber: {
      type: Number,
      default: 100
    },
    fileList: {
      type: Array,
      default: () => []
    },
    showAddIcon: {
      type: Boolean,
      default: true
    },
    type: {
      type: String,
      default: ''
    },
    license: {
      type: String,
      default: ''
    },
    managerIdentifyTop: {
      type: String,
      default: ''
    },
    managerIdentifyBottom: {
      type: String,
      default: ''
    },
  },
  watch: {
    license (val, vall) {
      this.imageUrl = val
    },
    managerIdentifyTop (val, vall) {
      this.imageUrl1 = val
    },
    managerIdentifyBottom (val, vall) {
      this.imageUrl2 = val
    }
  },
  data () {
    return {
      imageUrl: '',
      imageUrl1: '',
      imageUrl2: '',
      dialogImageUrl: '',
      dialogVisible: false
    }
  },
  methods: {
    submitUpload () { this.$refs.upload.submit() },
    uploadFile (e) {
      const file = e.file
      const size = file.size / 1024 / 1024 / 5
      console.log(size)
      if (!(file.type === 'image/png' || file.type === 'image/gif' || file.type === 'image/jpg' || file.type === 'image/jpeg')) {
        this.$notify.warning({
          title: '警告',
          message: '请上传格式为image/png, image/gif, image/jpg, image/jpeg的图片'
        })
        return
      } else if (size > 5) {
        this.$notify.warning({
          title: '警告',
          message: '图片大小必须小于5M'
        })
        return
      } else {
        const params = new FormData()
        params.append('file', file) // 图片
        console.log(params)
        this.$api.uploadFiles5(params).then(res => {
          if (res.code === 0) {
            this.$message.success('上传成功')
            console.log(this.type)
            if (this.type == 0) {
              this.imageUrl = this.ImgHttps + res.data.url
              this.$emit('getUrl', this.imageUrl)
            } else if (this.type == 1) {
              this.imageUrl1 = this.ImgHttps + res.data.url
              this.$emit('getUrl', this.imageUrl1)
            } else {
              this.imageUrl2 = this.ImgHttps + res.data.url
              this.$emit('getUrl', this.imageUrl2)
            }

          } else {
            this.$message.error('上传失败')
          }
        })
      }
    },
    // 图片上传超过数量限制
    handleExceed (files, fileList) {
      this.$message.error('图片数量超出限制!')
      console.log(files, fileList)
    },
    // 删除图片
    beforeRemove (file, fileList) {
      const url = file.url
      this.$emit('handleRemove', url)
    },
    // 预览图片
    handlePictureCardPreview (file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    }
  }
}
</script>
<style lang="scss">
.el-dialog .el-dialog__header {
  border-bottom: none;
}
.uploadBefore {
  width: 300px;
  height: 150px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  text-align: center;
  .icon {
    font-size: 28px;
    color: #8c939d;
    width: 300px;
    height: 150px;
    line-height: 150px;
    text-align: center;
  }
}
.uploadBefore:hover {
  border-color: #409eff;
}
.avatar {
  width: 308px;
  height: 150px;
  display: block;
  // background: url("../../../assets/zheng.png");
}
.avatarNone {
  width: 308px;
  height: 150px;
  display: block;
  background: url("../../../assets/zheng.png");
  text-align: center;
}
</style>
